/**
 * IOSAudioBypass.tsx
 * =============================================================================
 * Hidden, looping DOM audio element that forces iOS Safari to maintain the
 * audio session as AVAudioSessionCategoryPlayback ("Media" channel), bypassing
 * the physical hardware mute switch.
 *
 * KEY: The `loop` attribute keeps the audio session in "Playback" mode
 * indefinitely. Without it, iOS reverts to "Ambient" when the track ends.
 *
 * AudioEngine.ensureContext() finds this element by ID and calls .play()
 * on the first user gesture, BEFORE creating the AudioContext.
 *
 * @author Neuro-Audio Lab
 */

export function IOSAudioBypass() {
  return (
    <audio
      id="ios-media-bypass"
      src="/audio/near-silence.m4a"
      preload="auto"
      loop
      style={{ display: 'none' }}
    />
  );
}
